// Embeds the VF time zone provider
// eslint-disable-next-line no-restricted-imports
import { TimeZoneProviderProps, TimeZoneProvider as VizFrameworkTimeZoneProvider } from '@chronosphereio/viz-framework';
import React from 'react';
// Passes the user's time zone to the VF time zone picker
// eslint-disable-next-line no-restricted-imports
import { useUserTimeZone } from '@/context/UserTimePreferencesProvider';

export function TimeZoneProvider({
  initialTimeZone,
  disableURLParams = false,
  children,
}: Omit<TimeZoneProviderProps, 'userTimeZone'>) {
  const { timeZone } = useUserTimeZone();
  return (
    <VizFrameworkTimeZoneProvider
      userTimeZone={timeZone}
      initialTimeZone={initialTimeZone}
      disableURLParams={disableURLParams}
    >
      {children}
    </VizFrameworkTimeZoneProvider>
  );
}
